const BUY_NOW_SELECTOR = '[data-so-buy-now]';

document.addEventListener('click', async (event) => {
  if (!(event.target instanceof Element)) return;

  const button = event.target.closest(BUY_NOW_SELECTOR);
  if (!(button instanceof HTMLButtonElement) || button.disabled) return;

  const form = button.closest('form[action*="/cart/add"]');
  if (!(form instanceof HTMLFormElement)) return;

  const label = button.querySelector('[data-so-buy-now-label]');
  const initialLabel = label?.textContent || 'Buy it now';
  const root = window.Shopify?.routes?.root || '/';

  button.disabled = true;
  button.setAttribute('aria-busy', 'true');
  if (label) label.textContent = 'Taking you to checkout...';

  try {
    const response = await fetch(`${root}cart/add.js`, {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'X-Requested-With': 'XMLHttpRequest',
      },
      credentials: 'same-origin',
      body: new FormData(form),
    });

    const result = await response.json();
    if (!response.ok) {
      throw new Error(result.description || result.message || 'Unable to add this item.');
    }

    window.location.assign(`${root}checkout`);
  } catch (error) {
    button.disabled = false;
    button.removeAttribute('aria-busy');
    if (label) label.textContent = 'Try again';

    const liveRegion = form.closest('product-form-component')?.querySelector('[ref="liveRegion"]');
    if (liveRegion) {
      liveRegion.textContent = error instanceof Error ? error.message : 'Unable to continue to checkout.';
    }

    window.setTimeout(() => {
      if (label) label.textContent = initialLabel;
    }, 2500);
  }
});
